import { gql } from "@apollo/client";

export const GET_BLOGS = gql`
    query Blogs {
        blogs {
            date
            description
            id
            title
            slug
            image {
                url
            }
        }
    }
`;

export const GET_PROJECTS = gql`
    query Projects {
        portfolios {
            id
            slug
            title
            description
            author
            image {
                url
            }
        }
    }
`;

export const GET_PROJECT = gql`
    query Projects($slug: String!) {
        portfolios(where: { slug: $slug }) {
            id
            slug
            title
            description
            author
            image {
                url
            }
        }
    }
`;

export const GET_BLOG = gql`
    query Blogs($slug: String!) {
        blogs(where: { slug: $slug }) {
            date
            description
            id
            title
            slug
            image {
                url
            }
        }
    }
`;

export const GET_SERVICES = gql`
    query Services {
        services {
            title
        }
    }
`;

export const GET_FIRST_YEAR = gql`
    query Eerstejaars {
        eersteJaars {
            id
            programma
            studiepunten
            periode
            aantalUur
        }
    }
`;

export const GET_SECOND_YEAR = gql`
    query Tweedejaars {
        tweedeJaars {
            id
            programma
            studiepunten
            periode
            aantalUur
        }
    }
`;

export const GET_OPLEIDING_LIST = gql`
    query Opleidingen {
        opleidings {
            title
            description
        }
    }
`;

export const GET_TEAM_MEMBERS = gql`
    query Teams {
        teams {
            name
            id
            image {
                url
            }
            docents {
                ... on EersteJaar {
                    programma
                }
            }
        }
    }
`;

export const GET_SEARCH_PAGE = gql`
    query Search($slug: String!) {
        blogs(where: { title_contains: $slug }) {
            date
            description
            id
            title
            slug
            image {
                url
            }
        }
        portfolios(where: { title_contains: $slug }) {
            id
            slug
            title
            description
            author
            image {
                url
            }
        }
    }
`;
